import React, { useState } from "react";

import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import { ToolsBento, CardSamplesStrip } from "@/components/site/HomeTools";
import TreeDemo from "@/components/site/TreeDemo";
import FeaturedTrees from "@/components/site/FeaturedTrees";
import GeographicBrowser from "@/components/site/GeographicBrowser";
import Memorials from "@/components/site/Memorials";
import { HeritageBento, Migration, HistoricalRecords } from "@/components/site/Editorial";
import { FinalCTA, SiteFooter } from "@/components/site/FinalCTA";
import AuthDialog from "@/components/site/AuthDialog";
import { useAuth } from "@/context/AuthContext";

export default function Landing() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authTab, setAuthTab] = useState("register");
  const { user } = useAuth();

  const startTree = () => {
    if (user) {
      document.getElementById("tree-demo")?.scrollIntoView({ behavior: "smooth" });
    } else {
      setAuthTab("register");
      setAuthOpen(true);
    }
  };

  return (
    <div className="min-h-screen bg-ivory text-ink">
      <main>
        <Hero onCta={startTree} />
        <Marquee />
        <ToolsBento />
        <Manifesto />
        <CardSamplesStrip />
        <TreeDemo />
        <FeaturedTrees />
        <GeographicBrowser />
        <Memorials />
        <HeritageBento />
        <Migration />
        <HistoricalRecords />
        <FinalCTA onStart={startTree} />
      </main>
      <SiteFooter />
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} initialTab={authTab} />
    </div>
  );
}
